import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

import { NormasService } from '../_services/normas.service';
import { EvidenciasService } from '../_services/evidencias.service';
import { UsuariosService } from '../_services/usuarios.service';

import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';

import { Norma } from '../_models/norma.model';
declare var jQuery:any;

@Component({
  selector: 'inventarionormaspenal',
  templateUrl: 'inventarionormaspenal.template.html'
  //providers:  [PreguntasService]
})
export class InventarioNormasPenalComponent  implements OnInit, OnDestroy {

  subscription: Subscription;

  formbloque: boolean = false;
  formarea: boolean = false;
  formmodulo: boolean = false;
  formnorma: boolean = false;
  formevidencia: boolean = false;

  detallebloque: boolean = true;
  detallearea: boolean = true;
  detallemodulo: boolean = true;
  detallenorma: boolean = true;
  detalleevidencia: boolean = true;

  bloqueseleccionado: number = 0;
  areaseleccionada: number = 0;
  moduloseleccionado: number = 0;
  normaseleccionada: number = 0;
  normaseleccionadamaestra: number = 0;
  evidenciaseleccionada: number = 0;

  nombrebloqueseleccionado : string = "";
  nombreareaseleccionada : string = "";
  nombremoduloseleccionado : string = "";
  nombrenormaseleccionada : string = "";
  nombreevidenciaseleccionada : string = "";

  copianorma: boolean = false;
  copiaevidencia: boolean = false;

  puedoeditarnorma: boolean = true;
  puedoeditarevidencia: boolean = true;

  listabloques: any=[];
  listaareas: any=[];
  listamodulos: any=[];
  listanormas: any=[];
  listaevidencias: any=[];
  listaEvidenciasFiltro: any = [];

  etiquetabloque: string = "";
  etiquetaarea: string = "";
  etiquetamodulo: string = "";
  etiquetanorma: string = "";
  etiquetaevidencia: string = "";

  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';

  currentTimeout: number;

  volveranadir: boolean = false;

  listapermisos: any = [];

  verpermisos: boolean = false;
  id_permiso: number = 0;
  tipopermisos: string = "";
  titulopermiso: string = "";
  permisosbloques: boolean = false;
  permisosareas: boolean = false;
  permisosmodulos: boolean = false;
  permisosnormas: boolean = false;
  permisosevidencias: boolean = false;
  permisocrearbloque: boolean = false;
  permisocreararea: boolean = false;
  permisocrearmodulo: boolean = false;
  permisocrearnorma: boolean = false;
  permisocrearevidencia: boolean = false;

  mostrarmodalnormasmaestras: boolean = false;
  mostrarmodalevidenciasmaestras: boolean = false;
  mostrarFiltros:boolean = false;

  constructor(private seguridad: SeguridadService,
              private router:Router,
              private normasService: NormasService,
              private usuariosService : UsuariosService,
              private evidenciasService: EvidenciasService,
              private globalEventsManager: GlobalEventsManager,
              private confirmationService: ConfirmationService,
              private activatedRoute: ActivatedRoute){
  }

  ngOnInit(){

    this.globalEventsManager.menuExtendido(true);


    let breadcrumb: any = [
      {
        'path':'#',
        'name': 'Captura de Evidencias Penal'
      }];

    this.globalEventsManager.setNombrePagina(breadcrumb);

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

    this.getListaBloques();

    this.getListaPermisos();

  }

  stripText(val: string){
    var cadena: string = "";

    if (val != null){
      if (val.length>25){
        cadena = val.substr(0, 25)+"...";
      }else{
        cadena = val;
      }
    }

    return cadena;
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  volverAnadir(event){

    this.volveranadir = event;

    if(event){

    }

  }

  scrollLienzo(){

    jQuery(".wrap-app").animate({scrollLeft: 5000}, 1000);
  }

  nuevoBloque(){
    this.editarBloque(0);
  }

  borrarBloque(id_areadelito:number){

    this.normasService.deleteAreaDelito(id_areadelito).subscribe(
      data => {
        if (data){
          this.getListaBloques();
        }
      }
    );
  }

  confirmBloque(id_bloque: number) {
      this.confirmationService.confirm({
          message: '¿Seguro que deseas eliminar el bloque?',
          accept: () => {
              this.borrarBloque(id_bloque);
          }
      });
  }

  cerrar(nivel:number){

    //le pasamos el nivel al que tiene que ir

    if (nivel <= 1){
      this.bloqueseleccionado = 0;
      this.nombrebloqueseleccionado = "";
      this.detallebloque = true;
      this.formbloque = false;
    }

    if (nivel <= 2){
      this.areaseleccionada = 0;
      this.nombreareaseleccionada = "";
      this.detallearea = true;
      this.formarea = false;
    }

    if (nivel <= 3){
      this.moduloseleccionado = 0;
      this.nombremoduloseleccionado = "";
      this.detallemodulo = true;
      this.formmodulo = false;
    }

    if (nivel <= 4){
      this.normaseleccionada = 0;
      this.normaseleccionadamaestra = 0;
      this.nombrenormaseleccionada = "";
      this.detallenorma = true;
      this.formnorma = false;
    }

    if (nivel <= 5){
      this.evidenciaseleccionada = 0;
      this.nombreevidenciaseleccionada = "";
      this.detalleevidencia = true;
      this.formevidencia = false;
    }

    this.scrollLienzo();
    this.actualizarBreadcrumb();
  }

  expandir(nivel:number){
    if (nivel == 1){
      (this.detallebloque) ? this.detallebloque = false : this.detallebloque = true;
    }
    if (nivel == 2){
      (this.detallearea) ? this.detallearea = false : this.detallearea = true;
    }
    if (nivel == 3){
      (this.detallemodulo) ? this.detallemodulo = false : this.detallemodulo = true;
    }
    if (nivel == 4){
      (this.detallenorma) ? this.detallenorma = false : this.detallenorma = true;
    }
    if (nivel == 5){
      (this.detalleevidencia) ? this.detalleevidencia = false : this.detalleevidencia = true;
    }
  }

  actualizarBreadcrumb(){
    let breadcrumb: any = [];

    let item = {
      'path':'#',
      'name': 'Captura de Evidencias Penal'
    };
    breadcrumb.push(item);

    if (this.nombrebloqueseleccionado != ""){
      let item = {
        'path':'#',
        'name': this.nombrebloqueseleccionado
      }
      breadcrumb.push(item);
    }

    if (this.nombreareaseleccionada != ""){
      let item = {
        'path':'#',
        'name': this.nombreareaseleccionada
      }
      breadcrumb.push(item);
    }

    if (this.nombremoduloseleccionado != ""){
      let item = {
        'path':'#',
        'name': this.nombremoduloseleccionado
      }
      breadcrumb.push(item);
    }

    if (this.nombrenormaseleccionada != ""){
      let item = {
        'path':'#',
        'name': this.nombrenormaseleccionada
      }
      breadcrumb.push(item);
    }

    this.globalEventsManager.setNombrePagina(breadcrumb);
  }

  getListaPermisos(){
    this.usuariosService.getUsuarioListaPermisos().subscribe(
      data => {
        if (data){
          this.listapermisos = data.json().lista;

          //console.log(this.listapermisos);

          for (let i = 0; i < this.listapermisos.length; i++){
            if (this.listapermisos[i].codigo == "USERACCESS009"){
              this.permisosbloques = true;
              this.permisosareas = true;
              this.permisosmodulos = true;
              this.permisosnormas = true;
              this.permisosevidencias = true;
            }
            if (this.listapermisos[i].codigo == "MOD0001"){
              this.permisocrearbloque = true;
            }
            if (this.listapermisos[i].codigo == "MOD0004"){
              this.permisocreararea = true;
            }
            if (this.listapermisos[i].codigo == "MOD0007"){
              this.permisocrearmodulo = true;
            }
            if (this.listapermisos[i].codigo == "MOD0010"){
              this.permisocrearnorma = true;
            }
            if (this.listapermisos[i].codigo == "MOD0013"){
              this.permisocrearevidencia = true;
            }
          }

        }
      }
    );
  }

  onClosePermisos(event){
    if (event){
      this.verpermisos = false;
    }
  }

  verPermisos(tipo: string, titulopermiso: string, id_permiso: number){
    this.tipopermisos = tipo;
    this.titulopermiso = titulopermiso;
    this.verpermisos = true;
    this.id_permiso = id_permiso;
    this.scrollLienzo();
  }

  verBloque(id_bloque:number, nombre_bloque: string){

    this.detallebloque = false;
    this.bloqueseleccionado = id_bloque;
    this.nombrebloqueseleccionado = nombre_bloque;
    this.getListaAreas(this.bloqueseleccionado);
    this.formbloque = false;

    this.resetArea();

    this.scrollLienzo();

    this.verpermisos = false;

    this.actualizarBreadcrumb();

    //this.router.navigateByUrl('/in/' +id_bloque );
    //this.router.navigate(['in', id_bloque]);

    /*this.currentTimeout = window.setTimeout(() => {
      //alert('working');
      this.scrollLienzo();
    }, 100);*/

  }

  onChangeBloque(event){

    //console.log(event);

    if(event.anadir == false){
      this.cerrar(1);
      this.getListaBloques();
    }else{
      this.getListaBloques();
    }
  }

  editarBloque(id_bloque: number){
    if (id_bloque != 0){
      this.etiquetabloque = "Editar Área del Delito";
    }else{
      this.etiquetabloque = "Nueva Área del Delito";
    }
    this.detallebloque = false;
    this.bloqueseleccionado = id_bloque;
    this.formbloque = true;

    this.resetArea();

    this.scrollLienzo();

  }

  getListaBloques(){
    this.normasService.getListaAreasDelito().subscribe(
      data => {
        if (data){
          if (data.json().lista){
            this.listabloques = data.json().lista;
          }
        }
      }
    );
  }


  nuevaArea(){
    this.editarArea(0);
  }

  borrarArea(id_riesgo: number){
    this.normasService.deleteRiesgo(id_riesgo).subscribe(
      data => {
        if (data){
          this.getListaAreas(this.bloqueseleccionado);
        }
      }
    );
  }

  confirmArea(id_area: number) {
      this.confirmationService.confirm({
          message: '¿Seguro que deseas eliminar el área?',
          accept: () => {
              this.borrarArea(id_area);
          }
      });
  }

  cerrarArea(){

  }

  resetArea(){
    this.listaareas = [];
    this.areaseleccionada = 0;
    this.nombreareaseleccionada = "";
    this.formarea = false;
    this.detallearea = true;

    this.resetModulo();
  }

  verArea(id_area:number, nombre_area: string){
    this.detallearea = false;
    this.areaseleccionada = id_area;
    this.nombreareaseleccionada = nombre_area;
    this.getListaModulos(this.areaseleccionada);
    this.formarea = false;

    this.resetModulo();

    this.scrollLienzo();

    this.verpermisos = false;

    this.actualizarBreadcrumb();
  }

  editarArea(id_area:number){
    if (id_area != 0){
      this.etiquetaarea = "Editar Riesgo";
    }else{
      this.etiquetaarea = "Nuevo Riesgo";
    }
    this.detallearea = false;
    this.areaseleccionada = id_area;
    this.formarea = true;

    this.resetModulo();

    this.scrollLienzo();
  }

  getListaAreas(id_areadelito: number){
    this.normasService.getListaRiesgos(id_areadelito).subscribe(
      data => {
        if (data){
          if (data.json().lista){
            this.listaareas = data.json().lista;
          }
        }
      }
    );
  }

  onChangeArea(event){

    /*if(event){
      this.cerrar(2);
      this.getListaAreas(this.bloqueseleccionado);
    }*/
    if(event.anadir == false){
      this.cerrar(2);
    }
    this.getListaAreas(this.bloqueseleccionado);

  }


  nuevoModulo(){
    this.editarModulo(0);
  }

  borrarModulo(id_supuesto: number){
    this.normasService.deleteSupuesto(id_supuesto).subscribe(
      data => {
        if (data){
          this.getListaModulos(this.areaseleccionada);
        }
      }
    );
  }

  confirmModulo(id_modulo: number) {
      this.confirmationService.confirm({
          message: '¿Seguro que deseas eliminar el módulo?',
          accept: () => {
              this.borrarModulo(id_modulo);
          }
      });
  }

  cerrarModulo(){

  }

  resetModulo(){
    this.listamodulos = [];
    this.moduloseleccionado = 0;
    this.nombremoduloseleccionado = "";
    this.formmodulo = false;
    this.detallemodulo = true;

    this.resetNorma();
  }

  verModulo(id_modulo:number, nombre_modulo : string){
    this.detallemodulo = false;
    this.moduloseleccionado = id_modulo;
    this.nombremoduloseleccionado = nombre_modulo;
    this.formmodulo = false;
    this.getListaNormas(this.moduloseleccionado);

    this.resetNorma();

    this.scrollLienzo();

    this.actualizarBreadcrumb();

    this.verpermisos = false;
  }

  editarModulo(id_modulo:number){
    if (id_modulo != 0){
      this.etiquetamodulo = "Editar Supuesto";
    }else{
      this.etiquetamodulo = "Nuevo Supuesto";
    }
    this.detallemodulo = false;
    this.moduloseleccionado = id_modulo;
    this.formmodulo = true;

    this.resetNorma();

    this.scrollLienzo();
  }

  getListaModulos(id_riesgo:number){
    this.normasService.getListaSupuestos(id_riesgo).subscribe(
      data => {
        if (data){
          if (data.json().lista){
            this.listamodulos = data.json().lista;
          }
        }
      }
    );
  }

  onChangeModulo(event){
    /*if(event){
      this.cerrar(3);
      this.getListaModulos(this.areaseleccionada);
    }*/
    if(event.anadir == false){
      this.cerrar(3);
    }
    this.getListaModulos(this.areaseleccionada);
  }


  nuevaNorma(){
    this.editarNorma(0);
  }

  borrarNorma(id_control: number){
    this.normasService.deleteControl(id_control).subscribe(
      data => {
        if (data){
          this.getListaNormas(this.moduloseleccionado);
        }
      }
    );
  }

  confirmNorma(norma: any) {
      this.confirmationService.confirm({
          message: '¿Seguro que deseas eliminar el control?',
          accept: () => {
              this.borrarNorma(norma.id_control);
          }
      });
  }

  cerrarNorma(){

  }

  resetNorma(){
    this.listanormas = [];
    this.normaseleccionada = 0;
    this.normaseleccionadamaestra = 0;
    this.nombrenormaseleccionada = "";
    this.formnorma = false;
    this.detallenorma = true;

    this.resetEvidencia();
  }

  visualizarNorma(norma:any){
    this.copianorma = false;
    this.puedoeditarnorma = false;
    this.getEditarNorma(norma);
  }

  editarNorma(norma:any){
    this.copianorma = false;
    this.puedoeditarnorma = true;
    this.getEditarNorma(norma);
  }

  copiarNorma(norma:any){
    this.puedoeditarnorma = true;
    this.copianorma = true;
    this.getEditarNorma(norma);
  }

  getEditarNorma(norma:any){
    /*if (id_norma != 0){
      this.etiquetanorma = "Editar Norma";
    }else{
      this.etiquetanorma = "Nueva Norma";
    }
    if (!this.puedoeditarnorma){
      this.etiquetanorma = "Norma";
    }*/
    this.detallenorma = false;
    this.normaseleccionada = norma.id_control;
    this.normaseleccionadamaestra = norma.id_norma_maestra;
    this.formnorma = true;

    this.scrollLienzo();
  }

  getListaNormas(id_supuesto: number){
    this.normasService.getListaControles(id_supuesto).subscribe(
      data => {
        if (data){
          if (data.json().lista){
            this.listanormas = data.json().lista;
          }

          console.log(this.listanormas);
        }
      }
    );
  }

  anadirNormaMaestra(){
    this.mostrarmodalnormasmaestras = true;
  }

  onChangeModalNormasMaestras(event){
    this.mostrarmodalnormasmaestras = false;
    this.getListaNormas(this.moduloseleccionado);
    //this.globalEventsManager.getEvidenciasSinRelacionarCuestionario(this.id_cuestionario);
  }

  onChangeNorma(event){
    if(event){
      this.cerrar(4);
      this.getListaNormas(this.moduloseleccionado);
    }
  }

  onCloseNorma(event: number){
    this.cerrar(event);
  }

  verNorma(norma: any, nombre_norma: string){

    if (norma.id_control != 0){

      console.log(norma);

      this.resetEvidencia();
      this.detallenorma = false;
      this.normaseleccionada = norma.id_control;
      this.normaseleccionadamaestra = norma.id_norma_maestra;
      this.nombrenormaseleccionada = nombre_norma;
      this.getListaEvidencias(this.normaseleccionada);

      this.scrollLienzo();

      this.verpermisos = false;

      this.actualizarBreadcrumb();
    }

  }

  nuevaEvidencia(){

    this.editarEvidencia(0);
  }

  borrarEvidencia(id_evidencia: number){

    this.evidenciasService.deleteEvidenciaPenal(id_evidencia).subscribe(
      data => {
        if (data){
          this.getListaEvidencias(this.normaseleccionada);
          console.log("bool: " + this.formevidencia);
          this.scrollLienzo();
        }
      }
    );
  }

  confirmEvidencia(id_evidencia: number) {
      this.confirmationService.confirm({
          message: '¿Seguro que deseas eliminar la evidencia?',
          accept: () => {
              this.borrarEvidencia(id_evidencia);
          }
      });
  }

  cerrarEvidencia(){

  }

  anadirEvidenciaMaestra(){
    this.mostrarmodalevidenciasmaestras = true;
    this.scrollLienzo();
  }

  onChangeModalEvidenciasMaestras(event){
    this.mostrarmodalevidenciasmaestras = false;
    this.getListaEvidencias(this.normaseleccionada);
    this.scrollLienzo();
  }

  resetEvidencia(){
    this.listaevidencias = [];
    this.evidenciaseleccionada = 0;
    this.formevidencia = false;
    this.detalleevidencia = true;
  }

  visualizarEvidencia(id_evidencia: number){
    this.copiaevidencia = false;
    this.puedoeditarevidencia = false;
    this.getEditarEvidencia(id_evidencia);

    this.verpermisos = false;
  }

  editarEvidencia(id_evidencia:number){
    this.puedoeditarevidencia = true;
    this.copiaevidencia = false;
    this.getEditarEvidencia(id_evidencia);
  }

  copiarEvidencia(id_evidencia:number){
    this.puedoeditarevidencia = true;
    this.copiaevidencia = true;
    this.getEditarEvidencia(id_evidencia);
  }

  getEditarEvidencia(id_evidencia: number){

    /*if (id_evidencia != 0){
      this.etiquetaevidencia = "Editar Evidencia";
    }else{
      this.etiquetaevidencia = "Nueva Evidencia";
    }
    if (!this.puedoeditarevidencia){
      this.etiquetaevidencia = "Evidencia";
    }*/
    this.detalleevidencia = false;
    this.evidenciaseleccionada = id_evidencia;
    this.formevidencia = true;

    this.scrollLienzo();
  }

  getListaEvidencias(id_control: number) {

    console.log("bool: " + this.formevidencia);

    this.evidenciasService.getListaEvidenciasPenal(id_control).subscribe(
        data => {
          if (data){
            console.log(data.json());
            if (data.json().lista){
              this.listaevidencias = data.json().lista;
              this.listaEvidenciasFiltro = data.json().lista;
            }
          }
        }
    );
  }

  onChangeEvidencia(event){
    //if(event){
    if(event.anadir == false){
      this.cerrar(5);
      this.getListaEvidencias(this.normaseleccionada);
    }else{
      this.getListaEvidencias(this.normaseleccionada);
    }
  }

  onCloseEvidencia(event: number){
    this.cerrar(event);
  }


//---------------------------------------------------------------------
//-                            FILTROS
//---------------------------------------------------------------------
   
limpiarFiltros(){
    
  this.getListaEvidencias(this.normaseleccionada);


}

changeValueEvidenciaFiltros(filtro){

  this.listaevidencias = filtro;
  if (filtro.tipo == 'limpiar' ){
    this.limpiarFiltros();      
  }else{
    this.listaevidencias = filtro.value;
  
  }

 }



}



// WEBPACK FOOTER //
// ./src/app/inventarionormaspenal/inventarionormaspenal.component.ts